import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { toastr } from 'react-redux-toastr';
import Login from './component';
import { setLoading, onMobileChange, onPasswordChange, saveUser } from './actions';
import { getDataFromAPI, logoutUser } from '../HandleAPICalls/actions';
import Axios from 'axios'

class LoginContainer extends Component {
	constructor(props) {
		super(props);
		this.onChanegOfMobile = this.onChanegOfMobile.bind(this);
		this.onChangeOfPassword = this.onChangeOfPassword.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
	}

	onChanegOfMobile(e) {
		const { value } = e.target;
		this.props.onMobileChange(value);
	}

	onChangeOfPassword(e) {
		const { value } = e.target;
		this.props.onPasswordChange(value);
	}

	callPermissionApi(data) {
		let params = {
			"access-token": data.accessToken
		}
		Axios.post('https://api-prod.daalchini.co.in/dashboard/api/v2/admin/auth/permissions', params, {
			headers: {
				'Content-Type': 'application/json'
			}
		}).then((res) => {
			localStorage.setItem('allPermissions', JSON.stringify(res.data.data));
		})
			.catch((err) => {
				console.log("error faced while requesting -->>>", err);
			})
	}

	onSubmit(e) {
		const dataSet = e.target.dataset;
		if (!(dataSet.actiontype === 'Submit' || e.keyCode === 13)) {
			return false;
		}
		const mobile = this.props.login && this.props.login.mobile;
		const password = this.props.login && this.props.login.password;

		if (!/^[6789]\d{9}$/.test(mobile)) {
			return toastr.warning('Invalid Mobile Number', 'Please enter a 10-digit mobile number');
		}

		if (!password || password.length < 6) {
			return toastr.warning('Invalid Password', 'Password must be 6 chars long');
		}

		this.props.setLoading(true);
		return this.props.getDataFromAPI(
			'/login',
			'POST',
			{ mobile, password },
			(response) => {
				this.callPermissionApi(response);
				// console.log(response);
				// save user to localstorage
				localStorage.setItem('data', JSON.stringify(response));
				this.props.saveUser(response);
				this.props.setLoading(false);
				this.props.history.push('/home');
				return toastr.success('Success', 'Welcome onboard!');
			},
			(err) => {
				if (err.status === 404) {
					this.props.logoutUser();
					return toastr.error('Error', 'User not found');
				}
				this.props.setLoading(false);
				return toastr.error('Error', err.message);
			},
			true
		);

		
		
	}

	render() {
		const mobile = this.props.login && this.props.login.mobile;
		const password = this.props.login && this.props.login.password;
		const loading = this.props.login && this.props.login.loading;
		const disabled = Boolean(!mobile || (!password || password.length < 6));
		return (
			<Login
				mobile={mobile}
				password={password}
				disabled={disabled}
				loading={loading}
				onChanegOfMobile={this.onChanegOfMobile}
				onChangeOfPassword={this.onChangeOfPassword}
				onSubmit={this.onSubmit}
			/>
		);
	}
}

function mapStateToProps({ login }) {
	return {
		login
	};
}

export default withRouter(connect(mapStateToProps, {
	setLoading,
	onMobileChange,
	onPasswordChange,
	saveUser,
	getDataFromAPI,
	logoutUser
})(LoginContainer));



// WEBPACK FOOTER //
// ./src/Modules/Login/container.jsx